
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"45","height":"45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.894 16.106l8.606 8.588 8.606-8.588 2.644 2.644L22.5 30 11.25 18.75z"}}),_c('path',{attrs:{"d":"M0 0h45v45H0z","fill":"none"}})])
          )
        }
      }
    